import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './design/tokens.css'
import './design/base.css'

/**
 * The mount point.
 *
 * The two stylesheets are imported here, in this order, and nowhere else.
 * `base.css` reads tokens for its own document rules, so a bundler that saw
 * base first would emit it first and the body would paint an unstyled surface
 * before the custom properties existed. Importing them from a component instead
 * would tie the order to whichever screen happened to render first.
 *
 * `StrictMode` stays on. Its double mount is the point: an effect that
 * subscribes without unsubscribing shows up here as two listeners in
 * development rather than as a slow leak in a console somebody leaves open all
 * day.
 */

const container = document.getElementById('root')
// Thrown rather than logged. A console with no mount point cannot recover, and
// a silent failure leaves a blank cream page with nothing in it to explain why.
if (!container) throw new Error('The Namu console could not find its mount point.')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
